import type { IPlaceholderConfig, ITemplatePageConfig } from '~/types/template'

import BackgroundImageBlock from '~/components/DynamicScreen/Blocks/BackgroundImage'
import ButtonBlock from '~/components/DynamicScreen/Blocks/Button'
import SubTitleBlock from '~/components/DynamicScreen/Blocks/SubTitle'
import TextBlock from '~/components/DynamicScreen/Blocks/Text'
import TitleBlock from '~/components/DynamicScreen/Blocks/Title'

const placeholders: IPlaceholderConfig[] = [
  {
    category: 'arguments',
    component: TitleBlock,
    defaultValue: { color: '#2E2F31' },
    placeholderKey: 'title_txt_2',
    previewProperties: {
      text: 'Marketing argument for the second slide.',
    },
    type: ['color', 'translation'],
  },
  {
    category: 'arguments',
    component: SubTitleBlock,
    defaultValue: { color: '#2E2F31' },
    placeholderKey: 'subtitle_txt_2',
    previewProperties: {
      text: 'Subtitle arguments of the second slide onboarding. Can be on 50 characters. Be careful of your Lokalise translation',
    },
    type: ['color', 'translation'],
  },
  {
    category: 'button',
    className: 'button-text',
    component: TextBlock,
    defaultValue: { color: '#FFFFFF', translation: 'common.continue' },
    placeholderKey: 'continue_txt_2',
    type: ['color', 'translation'],
  },
  {
    category: 'button',
    component: ButtonBlock,
    defaultValue: { color: '#2871FF' },
    placeholderKey: 'action_next_cta_2',
    type: ['color'],
  },
]

export const marketingPage2: ITemplatePageConfig = {
  backgroundImage: 'background_img_2',
  className: 'page-2',
  name: '2. Marketing',
  placeholders: [
    ...placeholders,
    {
      category: 'background',
      component: BackgroundImageBlock,
      placeholderKey: 'background_img_2',
      type: 'asset',
    },
  ],
}

export const marketingPage2Video: ITemplatePageConfig = {
  ...marketingPage2,
  backgroundImage: 'background_video_2',
  placeholders: [
    ...placeholders,
    {
      category: 'background',
      component: BackgroundImageBlock,
      placeholderKey: 'background_video_2',
      type: 'asset',
    },
  ],
}
